class WagesRollService {
    constructor($sce, $http, Utility, $timeout, $rootScope, ContentService, LocalStorageService, InternalLinksService) {
        this.$sce = $sce;
        this.$http = $http;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.ContentService = ContentService;
        this.LocalStorageService = LocalStorageService;
        this.InternalLinksService = InternalLinksService;
        this.init();
    }

    init() {
        this.wagesRollData = undefined;
        this.wagesRollTotal = undefined;
    }
    async getWagesRoll(schemeRef, date) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('FinancialApiWagesRoll');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/financial/links');
                url = await this.InternalLinksService.getLink('FinancialApiWagesRoll');
            }

            url = url.replace('{schemeRef}', schemeRef).trim();

            const headers = this.Utility.headersWithContentType;

            if (!!!headers || (!!headers && (!!!headers.userName || !!!headers.sessionToken))) {
                const error = `Could not load Wages Roll as the 'Username' and/or 'Session Token' is missing`;
                this.$timeout(() => promiseHandler.reject(error));
            }

            const results = await this.$http.post(url, date, { headers });
            const { data } = results;

            this.wagesRollData = data;
            this.wagesRollTotal = 0;
            this.wagesRollData.forEach((value) => {
                this.wagesRollTotal += value.Amount;
            });
            this.$timeout(() => promiseHandler.resolve());
        } catch (err) {
            this.wagesRollData = null;
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }
}

export default /* @ngInject */ (
    $sce,
    $http,
    Utility,
    $timeout,
    $rootScope,
    ContentService,
    LocalStorageService,
    InternalLinksService
) =>
    new WagesRollService(
        $sce,
        $http,
        Utility,
        $timeout,
        $rootScope,
        ContentService,
        LocalStorageService,
        InternalLinksService
    );